var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"host-about"},[_c('Carousel'),_c('Intro'),_c('Mission'),_c('Recognition'),_c('Lics'),_c('Clients'),_c('Env')],1)}
var staticRenderFns = []

export { render, staticRenderFns }